import ActivityRecorder from 'core-lib/components/ActivityRecorder';
import AnalyticsScripts from 'core-lib/components/AnalyticsScripts';
import GenericUI from 'core-lib/components/GenericUI';
import InitStore from 'core-lib/components/InitStore';
import NativeAuthHandler from 'core-lib/components/NativeAuthHandler';
import NativeBackHandler from 'core-lib/components/NativeBackHandler';
import NetworkInterceptor from 'core-lib/components/NetworkInterceptor';
import QueuedEvents from 'core-lib/components/QueuedEvents';
import { updateReduxRestoreState } from 'core-lib/reduxStore/setting';
import { isServer, sendToGoogleAnalytics } from 'core-lib/utils/utils';
import { NextWebVitalsMetric } from 'next/app';
import { useEffect } from 'react';
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import { Provider, useDispatch } from 'react-redux';
import '../global.scss';

import { PAGE_LOAD_SIGNAL } from 'core-lib/constants/nativeBridge';
import { passMessageToNative } from 'core-lib/utils/nativeBridge';
import { isParkPlusWebView } from 'core-lib/utils/source';
import { store } from '../src/common/reduxStore/store';

export function reportWebVitals(metric: NextWebVitalsMetric) {
  if (!isServer()) {
    if (process.env.ENV === 'production') {
      sendToGoogleAnalytics(metric, 'SHOP');
    }
  }
}

function MyApp(props) {
  return (
    <Provider store={store}>
      <AppWrapper {...props} />
    </Provider>
  );
}

const AppWrapper = ({ Component, pageProps }) => {
  const dispatch = useDispatch();
  const handleOnDone = () => dispatch(updateReduxRestoreState(true));

  const { toasts } = useToasterStore();

  useEffect(() => {
    toasts
      .filter((t, i) => t.visible && i >= 3) // Only consider visible toasts
      .forEach(t => toast.dismiss(t.id)); // Dismiss – Use toast.remove(t.id) removal without animation
  }, [toasts]);

  useEffect(() => {
    if (isParkPlusWebView()) {
      passMessageToNative(PAGE_LOAD_SIGNAL, null, '');
    }
  }, []);

  return (
    <div className="wrapper">
      <div className="root">
        <Component {...pageProps} />
        <InitStore onDone={handleOnDone} />
        <GenericUI />
        <NetworkInterceptor />
        <ActivityRecorder />
        <NativeAuthHandler />
        <NativeBackHandler />
        <QueuedEvents />
        {!isServer() && <AnalyticsScripts />}

        <Toaster
          position="bottom-center"
          gutter={4}
          toastOptions={{
            style: {
              zIndex: 99999,
            },
            success: {
              duration: 3500,
              className: 'cmn_toast_container',
              icon: null,
            },
            error: {
              duration: 3500,
              className: 'cmn_toast_container',
              icon: null,
            },
          }}
        />
      </div>
    </div>
  );
};
export default MyApp;
